import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  
  private _loginapiUrl = `${environment.integration}` + "/Authenticate";
  // private _resetpasswordUrl = 

  constructor(
    private _http: HttpClient,
    private _router: Router
  ) { }

  public loginRequest(loginForm: { email: string, password: string }): Observable<any> {
    return this._http.post(this._loginapiUrl , loginForm);
  }

  logoutUser(navigateToLogin:boolean = true){
    // getting if user checked remember me
    const tempUserDetails = localStorage.getItem('userCredentials');
    localStorage.clear();
    if(tempUserDetails){
      localStorage.setItem('userCredentials', tempUserDetails)
    }
    if(navigateToLogin){
      this._router.navigate(['/login'])
    }    
  }

  resetPassword(){

  }
}
